import React from 'react';
import allergies from '../images/report-icons/allergies.svg';
import cardiac from '../images/report-icons/cardiac.svg';
import complaint from '../images/report-icons/complaint.svg';
import gi from '../images/report-icons/gi.svg';
import gu from '../images/report-icons/gu.svg';
import history from '../images/report-icons/history.svg';
import hospital from '../images/report-icons/hospital.svg';
import iv_fluids from '../images/report-icons/iv-fluids.svg';
import iv_sites from '../images/report-icons/iv-sites.svg';
import labs from '../images/report-icons/labs.svg';
import medications from '../images/report-icons/medications.svg';
import mobility from '../images/report-icons/mobility.svg';
import muscle from '../images/report-icons/muscle.svg';
import neuro from '../images/report-icons/neuro.svg';
import notes from '../images/report-icons/notes.svg';
import patient from '../images/report-icons/patient.svg';
import respiratory from '../images/report-icons/respiratory.svg';
import skin from '../images/report-icons/skin.svg';
import social_context from '../images/report-icons/social-context.svg';
import tests from '../images/report-icons/tests.svg';
import todo from '../images/report-icons/todo.svg';
import tubes from '../images/report-icons/tubes.svg';
import vitals from '../images/report-icons/vitals.svg';
import want from '../images/report-icons/want.svg';

// The Kabilah phone app's report-section icons (copied from
// kabilah-react-native/assets/icons/report), keyed by ReportItem.icon.
const ICONS = {
  'allergies': allergies,
  'cardiac': cardiac,
  'complaint': complaint,
  'gi': gi,
  'gu': gu,
  'history': history,
  'hospital': hospital,
  'iv-fluids': iv_fluids,
  'iv-sites': iv_sites,
  'labs': labs,
  'medications': medications,
  'mobility': mobility,
  'muscle': muscle,
  'neuro': neuro,
  'notes': notes,
  'patient': patient,
  'respiratory': respiratory,
  'skin': skin,
  'social-context': social_context,
  'tests': tests,
  'todo': todo,
  'tubes': tubes,
  'vitals': vitals,
  'want': want,
};

// Drawn as a mask so it takes the text color, like the app's tinted glyphs:
// black normally, purple for pinned sections. Unknown names fall back to
// 'notes', as in the app.
const ReportIcon = ({ name, size = 24 }) => {
  const url = ICONS[name] || ICONS.notes;
  return (
    <span
      className="report-icon"
      aria-hidden="true"
      style={{ width: size, height: size, WebkitMaskImage: `url(${url})`, maskImage: `url(${url})` }}
    />
  );
};

export default ReportIcon;
